import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { getStyle } from '../../../../utils/utils';
import CBMediaQuery from '../../../shared/CBMediaQuery';
import i18n from '../../../../i18n';

export default function TaskFilterBar({ filters, setFilters }) {
  const statusOptions = [
    { name: i18n.t('created', { ns: 'TaskListView' }), value: 'created' },
    { name: i18n.t('in_progress', { ns: 'TaskListView' }), value: 'in_progress' },
    { name: i18n.t('completed', { ns: 'TaskListView' }), value: 'done' },
    { name: i18n.t('cancelled', { ns: 'TaskListView' }), value: 'cancelled' },
  ]

  return (
    <CBMediaQuery>
      {screenSize => (
        <div style={getStyle(screenSize, styles, 'container')}>
          <div style={getStyle(screenSize, styles, 'filterContainer')}>
            <p>{i18n.t('search', { ns: 'common' })}</p>
            <InputText
              value={filters.search}
              placeholder={i18n.t('searchTasks', { ns: 'TaskListView' })}
              onChange={(e) => {
                return setFilters({ ...filters, search: e.target.value })
              }}
            />
          </div>
          <div style={styles.filterContainer}>
            <p>{i18n.t('visibleStatuses', { ns: 'TaskListView' })}</p>
            <MultiSelect
              value={filters.statuses}
              onChange={(e) => {
                if (e.value.length === 0) {
                  return;
                }
                return setFilters({ ...filters, statuses: e.value })
              }}
              options={statusOptions}
              optionLabel="name"
              placeholder={i18n.t('visibleStatuses', { ns: 'TaskListView' })}
              style={{ width: 240 }}
            />
          </div>
        </div>
      )}
    </CBMediaQuery>
  )
}


const styles = {
  default: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      gap: 16,
      padding: 8,
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'column',
    }
  },
  small: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      padding: 8,
    },
  }
}